module.exports = __webpack_public_path__ + "media/a-_.0fba21cf.mp3";